<template>
    <div>
        <b-modal id="modal-delete" title="Delete">
            <p>Are you sure?</p>
            <ul>
                <li>Deleting a tag will remove all references to it from posts.</li>
                <li>Posts that are tagged with this will not be affected.</li>
            </ul>
            <template #modal-footer="{ ok, cancel, hide }">
                <b-button variant="outline" @click="cancel()">Cancel</b-button>
                <b-button variant="danger" @click="deleteTag(deleteId)">Delete</b-button>
            </template>
        </b-modal>

        <loading v-if="loading"></loading>
        <div v-else>
            <div class="list-group">
                <template v-for="item in tags">
                    <div class="list-group-item bg-white">
                        <div class="d-flex align-items-center justify-content-between">
                            <div>{{item.tag}}</div>
                            <div>
                                <b-button variant="outline" class="btn-sm" @click="openEdit(item.id)"><b-icon icon="pencil"></b-icon></b-button>
                                <b-button variant="outline" @click="askDelete(item.id)" class="text-danger btn-sm"><b-icon icon="trash"></b-icon></b-button>
                            </div>
                        </div>

                        <div v-if="editId === item.id">
                            <hr/>
                            <validation-observer ref="observer" v-slot="{ passes }">
                                <form @submit.stop.prevent="passes(editTag)" class="row">
                                    <div class="col-12">
                                        <validation-provider name="tag" rules="min:2|required" v-slot="{ errors }">
                                            <b-form-input v-model="item.tag"></b-form-input>
                                            <span class="validation">{{ errors[0] }}</span>
                                        </validation-provider>
                                    </div>

                                    <div class="col-12">
                                        <a class="btn btn-outline mt-2 mr-2" @click='editId = 0'>Cancel</a>
                                        <button type="submit" class="btn btn-success mt-2">Save</button>
                                    </div>
                                </form>
                            </validation-observer>
                        </div>
                    </div>
                </template>
            </div>

            <b-button class="mt-4 btn-outline" @click='isNewFormOpen = true'>
                <b-icon-plus class="text-success"></b-icon-plus>
                New tag
            </b-button>

            <div v-if="isNewFormOpen">
                <hr/>
                <validation-observer ref="observer" v-slot="{ passes }">
                    <form @submit.stop.prevent="passes(createTag)">
                        <validation-provider name="tag" rules="min:2|required" v-slot="{ errors }">
                            <b-form-input v-model="tag" placeholder="Tag"></b-form-input>
                            <span class="validation">{{ errors[0] }}</span>
                        </validation-provider>

                        <a class="btn btn-outline mt-2 mr-2" @click='isNewFormOpen = false'>Cancel</a>
                        <button type="submit" class="btn btn-success mt-2">Create</button>
                    </form>
                </validation-observer>
            </div>
        </div>
    </div>
</template>

<script>
import NotificationPop from '../mixins/NotificationPop.js'
import Loading
    from "./Loading";

export default {
    name: "Tags",
    mixins: [NotificationPop],
    components: {
        Loading
    },
    data() {
        return {
            loading: true,
            tags: [],
            isNewFormOpen: false,
            editId: 0,
            deleteId: 0,
            tag: '',
        }
    },

    async created() {
        this.$http.get('/http_api/tags')
            .then(({data}) => {
                this.loading = false;
                this.tags = data.data
            })
            .catch(error => {
                this.loading = false;
                this.popNotification('Something went wrong on our side. Could not load tags. Please try again or contact ruben@boei.help', 'danger')
            });
    },
    methods: {
        /**
         * Create new tag
         */
        createTag: function () {
            this.$http.post('/http_api/tags', {
                tag: this.tag,
            })
                .then(({data}) => {
                    // add to list
                    this.tags.push(data.data);
                    // clear form and toggle
                    this.tag = '';
                    this.isNewFormOpen = false;
                    this.popNotification('Created', 'success');
                })
                .catch(error => {
                    console.log(error.response.data.errors);
                    this.popNotification('Could not create', 'danger');
                });
        },

        /**
         * Display edit form inside item
         * @param id tag id
         */
        openEdit: function (id) {
            let index = this.tags.findIndex(tag => tag.id === id);

            this.editId = id;
            this.tag = this.tags[index].tag;
        },

        /**
         * Save edit form
         */
        editTag: function () {
            let index = this.tags.findIndex(tag => tag.id === this.editId);

            this.$http.patch('/http_api/tags/' + this.editId, {
                tag: this.tags[index].tag, // Use the updated tag from the input
            })
                .then(({data}) => { // Change 'response' to 'data'
                    this.popNotification('Updated', 'success');
                    this.tags[index] = data.data; // Update the entire tag object

                    this.editId = 0; // close form
                })
                .catch(error => {
                    console.log(error.response.data.errors);
                    this.popNotification('Could not update', 'danger');
                });
        },

        /**
         * Show modal to ask for deletion
         * @param id
         */
        askDelete: function (id) {
            this.$bvModal.show('modal-delete');
            this.deleteId = id;
        },

        /**
         * After confirm, delete the tag
         * @param id tag id
         */
        deleteTag: function (id) {
            this.$bvModal.hide('modal-delete');

            let index = this.tags.findIndex(tag => tag.id === id);

            this.$http.delete('/http_api/tags/' + id)
                .then(({response}) => {
                    this.popNotification('Deleted', 'success');
                })
                .catch(error => {
                    console.log(error.response.data.errors);
                    this.popNotification('Could not delete', 'danger');
                });

            this.tags.splice(index, 1);
        },

    }
}
</script>
